import { Components } from '@mui/material/styles';
import palette from 'theme/palette';
import pxToEm from 'theme/pxToEm';

export const MuiMenuItem: Components['MuiMenuItem'] = {
  defaultProps: {
    disableRipple: true,
  },
  styleOverrides: {
    root: {
      fontSize: pxToEm(16),
      lineHeight: pxToEm(24),
      padding: pxToEm(4),
      color: palette.primary.main,
    },
  },
};

export const MuiMenu: Components['MuiMenu'] = {
  styleOverrides: {
    root: {
      '.MuiList-root': {
        padding: pxToEm(6),
        '.MuiMenuItem-root': {
          minHeight: pxToEm(32),
          maxHeight: pxToEm(32),
          marginBottom: pxToEm(4),
          padding: `0 0 0 ${pxToEm(6)}`,
          '&:hover, &:active, &.Mui-selected': {
            backgroundColor: 'unset',
          },
          borderRadius: '8px',
          '&:last-of-type': {
            marginBottom: 0,
          },
          '.MuiListItemIcon-root': {
            minWidth: pxToEm(32),
            maxWidth: pxToEm(32),
          },
          '.MuiListItemText-root': {
            span: {
              fontSize: pxToEm(14),
              marginTop: '2px',
            },
          },
          '.MuiTypography-body2': {
            span: {
              verticalAlign: 'middle',
            },
          },
        },
      },
      '.MuiPaper-root': {
        borderRadius: '8px',
        boxShadow: '0px 4px 25px rgb(0 0 0 / 8%)',
      },
    },
  },
};
